import { useCallback, useEffect, useState } from 'react'

import { useQuery, useReactiveVar } from '@apollo/client/react'
import { add, differenceInDays } from 'date-fns'

import { store } from '../cache'
import { DOLPHIN_RESERVATIONS } from '../queries/dolphinReservations'
import { toISOStringDate } from '../utils/toISOStringDate'

export function useAvailability(dayRange = 90, currentDate) {
  const today = new Date()
  const [startDate, setStartDate] = useState(today)
  const endDate = add(startDate, { days: dayRange })
  const { locationId } = useReactiveVar(store)
  const [serviceUnavailable, setServiceUnavailable] = useState(false)
  const [invalidStartDate, setInvalidStartDate] = useState(false)
  const [uncaughtError, setUncaughtError] = useState(false)
  const [reservations, setReservations] = useState([])

  const { data, loading, error } = useQuery(DOLPHIN_RESERVATIONS, {
    variables: {
      locationId,
      startDateUtc: toISOStringDate(startDate),
      endDateUtc: toISOStringDate(endDate),
    },
  })

  useEffect(() => {
    if (!loading && !error) {
      switch (data.dolphinReservations.__typename) {
        case 'DolphinReservations':
          const fetchedReservations = data.dolphinReservations.reservations
          if (fetchedReservations.length === 0) {
          } else {
            const combinedReservations =
              fetchedReservations.concat(reservations)
            setReservations(combinedReservations)
          }
          break
        case 'VendorServiceUnavailable':
          setServiceUnavailable(true)
          break
        case 'InvalidStartDate':
          setInvalidStartDate(true)
          break
        default:
          setUncaughtError(true)
          break
      }
    }
  }, [data, loading, error])

  const hasAvailability = !loading && !error && reservations.length > 0

  const loadNextBatch = useCallback(() => {
    setStartDate(endDate)
  }, [endDate])

  useEffect(() => {
    if (differenceInDays(currentDate, endDate) > 0) {
      loadNextBatch()
    }
  }, [currentDate, endDate])

  return {
    reservations,
    hasAvailability,
    serviceUnavailable,
    invalidStartDate,
    uncaughtError,
    loading,
    error,
  }
}
